import { Box, Stack, Typography } from "@mui/material";
import { SearchPostProps } from "../../interface/search";

import { PostContent } from "./contents";
import NewsFeedContainer from "../newsfeed-container";
import { formatTextType } from "../../utils/date-setup";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useNotificationService } from "../../hooks/notification";
import RepsSelectButton from "../ui-elements/reps-select-button";
import { useState } from "react";

export const SearchPost = ({ data }: { data: any[] }) => {
  return (
    <Box>
      {data?.length === 0 && (
        <Box
          sx={{
            width: 500,
            height: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            No results found in Posts
          </Typography>
        </Box>
      )}
      {data?.map((post: any, index: number) => (
        <PostContent post={post} key={index} />
      ))}
    </Box>
  );
};

export const SearchNewsfeed = ({ data }: { data: SearchPostProps }) => {
  return (
    <Box>
      {data?.data?.length === 0 && (
        <Box
          sx={{
            width: 500,
            height: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            No results found
          </Typography>
        </Box>
      )}
      {data?.data?.map((feed: any, index: number) => (
        <NewsFeedContainer
          report_id={feed?.report_id}
          entity_value={feed?.entity_value}
          place_admin_level={feed?.place_admin_level}
          place_geocode_name={feed?.place_geocode_name}
          report_title={feed?.report_title}
          report_content={feed?.report_content}
          report_url={feed?.report_url}
          report_date_published={feed?.report_date_published}
          source_name={feed?.source_name}
          source_type_name={feed?.source_type_name}
          post_type={feed?.post_type}
          author={feed?.author}
          author_id={feed?.author_id}
          incident_type={feed?.incident_type}
        />
      ))}
    </Box>
  );
};

export const SearchAccount = ({ data }: { data: any[] }) => {
  const verified = useSelector((state: RootState) => state.content.verified);
  const { showNotification } = useNotificationService();
  const [selectedButtons, setSelectedButtons] = useState("All");

  const handleButtonClick = (value: string) => {
    setSelectedButtons(value);
    if (value === "All") {
    }

  };
  const handleRepsNavigate = () => {
    // Navigate to representatives page
    // check if the user is verified before navigation
    if (verified) {
      // Navigate to representatives page
    } else {
      // Show notification to verify account before navigation
      showNotification(
        "Account profile has not been submitted, Kindly verify your account",
        "info"
      );
    }
  };
  
  return (
    <Box>
      {data?.length === 0 && (
        <Box
          sx={{
            width: 500,
            height: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            No results found in Account
          </Typography>
        </Box>
      )}
      {data?.length > 0 && (
        <RepsSelectButton
          handleButtonClick={handleButtonClick}
          selectedButtons={selectedButtons}
        />
      )}
      {data?.map((post: any, index: number) => (
        <Box
          key={index}
          sx={{
            my: 2,
            border: "1px solid #ccc",
            p: 2,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            gap: 3,
            cursor: "pointer",
          }}
          onClick={handleRepsNavigate}
        >
          <img
            alt=""
            src={post.photo_url}
            width={50}
            height={50}
            style={{ borderRadius: "50%" }}
          />
          <Stack sx={{ width: "90%" }}>
            <Stack direction={"row"} sx={{ gap: 1 }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600 }}
                color="black"
              >
                {post?.name}
              </Typography>
            </Stack>
            <Typography variant="caption" color="primary">
              {formatTextType(post?.account_type)}
            </Typography>
            <Typography variant="caption" color="primary">
              {formatTextType(post?.position)}
            </Typography>
            {post?.local_government && (
              <Typography variant="caption" color="primary">
                {formatTextType(post?.local_government)}
              </Typography>
            )}
            {post?.district && (
              <Typography variant="caption" color="primary">
                {formatTextType(post?.district)}
              </Typography>
            )}
            {post?.constituency && (
              <Typography variant="caption" color="primary">
                {formatTextType(post?.constituency)}
              </Typography>
            )}
            <Typography variant="caption">{post?.state ?? "-"}</Typography>
          </Stack>
        </Box>
      ))}
    </Box>
  );
};
